// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4f4511d0","453":"f2ce1e62","732":"9d495b29"}[chunkId] + ".chunk.js";
};